wbApp.controller('StudentsCtrl', ['$scope', '$q', '$modal', '$window', '$translate', '$filter', 'studentSvc', 'securitySvc', 'groupSvc', 'tenantSettingSvc', 'gridSortSvc',
function ($scope, $q, $modal, $window, $translate, $filter, studentSvc, securitySvc, groupSvc, tenantSettingSvc, gridSortSvc) {

    $scope.tenantSetting = tenantSettingSvc.settings;
    
    var isInCourseRole = securitySvc.isInRole('Course');
    var isInActionRole = securitySvc.isInRole('Action');
    var isInAttendanceRole = securitySvc.isInRole('Attendance');
    $scope.isInProtectedViewRole = securitySvc.isInRole('Student.ProtectedView');

    $scope.groups = groupSvc.getAllAsync(true);
    $scope.customFilter = { selectedGroups: [] };
    $scope.rawStudents = [];
    $scope.students = [];
    $scope.filteredStudents = [];

    function preFilter() {
        $q.all([$scope.groups.$promise, $scope.rawStudents.$promise]).then(function () {
            if (!$scope.customFilter.selectedGroups.length) {
                $scope.students.length = 0;
                $scope.students.push.apply($scope.students, $scope.rawStudents);
            } else {

                var noGroupSelected = $scope.customFilter.selectedGroups.indexOf(-1) !== -1;

                $scope.students.length = 0;
                $scope.students.push.apply($scope.students,
                    _.filter($scope.rawStudents, function (o) {
                        if (noGroupSelected) {
                            return !o.groups.length;
                        }

                        return _.intersection(o.groups, $scope.customFilter.selectedGroups).length > 0
                    }));
            }
        });
    }
    
    $scope.groupsCombo = {
        items: $scope.groups,
        displayExpr: 'name',
        valueExpr: 'groupID',
        showSelectionControls: true,
        maxDisplayedTags: 3,
        multiline: false,
        itemTemplate: 'customItem',
        bindingOptions: {
            value: 'customFilter.selectedGroups'
        },
    }

    $scope.$watch('customFilter.selectedGroups', function (newValue, oldValue) {
        preFilter();
    }, true);


    $scope.gridSettings = {
        name: 'students',
        columns: [
            {
                dataField: 'fullName', caption: $translate.instant('TXT_HUMAN_NAME'), dataType: 'string', width: '180px', sortOrder: 'asc',
                calculateSortValue: function (data) { return gridSortSvc.sortHumanFullName(data, 'name', 'surname', 'middleName') },
            },
            {
                dataField: 'gender',
                caption: $translate.instant('TXT_LBL_GENDER'),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('gender')(rowData.gender);
                },
                width: '80px',
                visible: $scope.tenantSetting.mandatoryStudentGender < 3
            },
            { 
                dataField: 'birthday', 
                caption: $translate.instant("TXT_LBL_BIRTHDAY"), 
                dataType: 'date', 
                format: { date: 'short' }, 
                width: '70px',
                visible: $scope.tenantSetting.mandatoryStudentBirthday < 3
            },
            {
                dataField: 'parentFullName', caption: $translate.instant('TXT_LBL_PARENT'), dataType: 'string', width: '180px',
                calculateSortValue: function (data) { return gridSortSvc.sortHumanFullName2(data, 'parentFullName') }
            },
            { 
                dataField: 'address', 
                caption: $translate.instant('TXT_LBL_ADDRESS'), 
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    if (!!rowData.studentAddress ) {
                        return rowData.studentAddress;
                    }
                    return rowData.address;
                },
                         
            },
            { dataField: 'email', caption: $translate.instant('TXT_LBL_EMAIL'), dataType: 'string', width: '180px' },
            {
                dataField: 'phone',
                caption: $translate.instant('TXT_LBL_PHONE'),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('phone')(rowData.phone);
                },
                width: '130px'
            },
            { dataField: 'active', caption: $translate.instant('TXT_LBL_ACTIVE'), dataType: 'boolean', width: '60px' },
            { dataField: 'adminNotes', caption: $translate.instant('TXT_LBL_NOTE'), dataType: 'string', visible: false },
        ],
        shouldDisableExportMenu: function () {
            return !securitySvc.isInRole('Student.Export');
        },
        customCommands: [{
            text: $translate.instant('TXT_LBL_ACTIVITY_YEAR_PAYMENT_CONFIRMATION_REPORT'),
            isVisible: function () {
                return securitySvc.isInRole('Reports') &&
                       securitySvc.isInRole('ActivityYearPaymentConfirmation') &&
                    $scope.tenantSetting.enableKindergartenSupport;
            },
            callback: function (data) { showActivityYearPaymentConfirmationDialog(data.id); }
        }]
    }

    $scope.tabs = [{
        title: 'TXT_DETAIL',
        template: "users/students/detail-tabs/detail.html"
    }];

    if (isInCourseRole) {
        $scope.tabs.push({
            title: 'TXT_LBL_COURSES',
            template: "users/students/detail-tabs/courses.html"
        });
    }

    if (isInActionRole) {
        $scope.tabs.push({
            title: 'TXT_LBL_ACTIONS',
            template: "users/students/detail-tabs/actions.html"
        });
    }

    if (isInAttendanceRole) {
        $scope.tabs.push({
            title: 'TXT_LBL_ATTENDANCE_SUMMARY',
            template: "users/students/detail-tabs/attendance-summary.html"
        });

        $scope.tabs.push({
            title: 'TXT_LBL_ATTENDANCE_DETAIL',
            template: "users/students/detail-tabs/attendance-detail.html"
        });
    }

    $scope.tabs.activeTab = 0;

    $scope.selectedStudent = null;

    function setSelectedStudent(student, refresh) {
        $scope.selectedStudent = student;
        $scope.$broadcast('studentSelectionChanged', { student: $scope.selectedStudent, refresh: !!refresh });
    }

    $scope.$watch('tabs.activeTab', function (newValue, oldValue) {
        $scope.$broadcast('activeTabChanged', { activeTab: newValue });
    });

    $scope.rawStudents = studentSvc.getAll();

    preFilter();

    $scope.$on('refreshData', function (e, data) {
        $scope.rawStudents = studentSvc.getAll();
        setSelectedStudent(null);
    });

    $scope.onRowSelected = function (data) {
        setSelectedStudent(data);
    }

    $scope.onRowAdd = function () {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.collection = $scope.students;
            detailDialogPromise.$scope.model = studentSvc.createNew();
            detailDialogPromise.$scope.onStudentSave = function (model) {
                setSelectedStudent(model, true);
            };
            detailDialogPromise.show();
        });
    }

    $scope.onRowEdit = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.collection = $scope.students;
            detailDialogPromise.$scope.model = angular.copy(data);
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        studentSvc.remove(data, null, $scope.students);
    }

    $scope.onFilterApplied = function (rows) {
        $scope.filteredStudents = rows;
    }

    $scope.getStudentsActive = function () {
        if (!!$scope.filteredStudents) {
            return _.countBy($scope.filteredStudents, 'active')['true'] || 0;
        }

        return 0;
    }

    $scope.getStudentsCount = function () {
        if (!!$scope.filteredStudents) {
            return $scope.filteredStudents.length;
        }

        return 0;
    }

    $scope.getStudentsActivePercent = function () {
        return ($scope.getStudentsActive() / $scope.getStudentsCount()) * 100;
    }

    var detailDialogPromise = $modal({
        templateUrl: 'users/students/students-detail.html',
        show: false,
        scope: $scope.$new()
    });

    function showActivityYearPaymentConfirmationDialog(studentID) {

        activityTaxDeductionReportParamsDialog.$promise.then(function () {
            activityTaxDeductionReportParamsDialog.$scope.studentID = studentID;
            activityTaxDeductionReportParamsDialog.show();
        });
    }

    var activityTaxDeductionReportParamsDialog = $modal({
        templateUrl: 'users/students/students-tax-deduction-report-params.html',
        show: false,
        scope: $scope.$new()
    });
}]);


